import { useState, useEffect } from "react";
import CaseListV2 from "../caseListV2";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import "./ClaimCases.scss";
const ClaimCases = () => {
  const [selectedStage, setSelectedStage] = useState({
    id: "-1",
    stages: [
      "Claim Sent To Bank on TMS",
      "Claim Amount Paid by Bank on TMS",
      "Claim Received",
    ],
  });
  const [getDataCheck, setDataCheck] = useState(false);
  const handleGetAllCasesClick = (AllCases) => {
    if (getDataCheck) {
      AllCases();
      return;
    }
    setDataCheck(true);
  };
  return (
    <div className="claim-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Claimed Cases
      </span>
      <div className="heading">Claimed Cases</div>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />
      <CaseListV2
        handleGetAllCasesClick={handleGetAllCasesClick}
        getDataCheck={getDataCheck}
        selectedStage={selectedStage.stages}
        isFromClaimCases={true}
        setSelectedStage={setSelectedStage}
      />
    </div>
  );
};

export default ClaimCases;
